import React, { useRef } from 'react';
import { useFormContext } from '../../components/FormContext';


const DocumentsSection = () => {
  const { 
    formData, 
    formErrors, 
    modifiedFields,
    setFormErrors, 
    setFile,
    setModifiedFields
  } = useFormContext();

const passportInputRef = useRef(null);

const validatePDFFile = (field, e) => {
    
    const file = e.target.files[0];
    setFile('passportDocument', file);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
    if (!file) {
      
      error = `PDF file is required for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
      
    } else if (file.type !== 'application/pdf') {
        
      error = `PDF file is only excepted for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
    } 
        
        
      

   
    
    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };


return (

  <div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Passport Document Upload</h4>
      
      <div className="space-y-4"> 
                <div>
                  <input
                    id="passport-document-upload"
                    type="file"
                    name="passportDocument"
                    accept=".pdf"
                    className="hidden"
                    onChange={(e) => validatePDFFile('passportDocument', e)}
                    ref={passportInputRef}
                  />
                  
                  {!formData.passportDocument ? (
                    <button
                      type="button"
                      onClick={() => passportInputRef.current.click()}
                      className="upload-button flex items-center justify-center px-4 py-2 w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg shadow hover:from-blue-600 hover:to-indigo-700 transition-all duration-200"
                    >
                      <span className="font-medium">Upload Passport Document</span>
                    </button>
                  ) : (
                    <div className="file-info p-3 bg-gray-50 rounded-md border border-gray-200">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center">
                          <span className="file-name text-sm font-medium text-gray-700">
                            {formData.passportDocument.name}
                          </span>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            setFile('passportDocument', null);
                            // Use the existing validation function with a mock empty event
                            validatePDFFile('passportDocument', { target: { files: [] } });
                          }}
                          className="text-sm text-red-600 hover:text-red-800 font-medium"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  )}
                  
                  {formErrors.passportDocument && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('passportDocument') && (
                    <div className="text-sm text-red-600 mt-1">
                      {formErrors.passportDocument}
                    </div>
                  )}
                </div>
              </div>
            </div>

  );
};

export default DocumentsSection;